import React from 'react'
import { useSelector } from 'react-redux';
import { ContactsContainer } from '../../styles/contacts_and_service_template';
import { getFormatedTel } from '../../functions/getFormatedTel';

export const Contacts = () => {


    const data = useSelector(state => state.firebase.data.main_data)

    return (
        <ContactsContainer>
            <div className="background-rectangle" />
            <div className='width-limiter'>
                {data
                    ? <>
                        <TextItem text={`ООО «Флагман»`} />
                        <TextItem text={`Юридический адрес: ${data.legal_address}`} />
                        <TextItem text={`ИНН: ${data.inn}`} />
                        <TextItem text={`КПП: ${data.kpp}`} />
                        
                        <div className="text-container">
                            <div className="dot" />
                            <p className='text'>Конт. тел.: <a href={`tel:${ getFormatedTel(data.tel) }`}> {data.tel} </a></p>
                        </div>

                        <div className="text-container">
                            <div className="dot" />
                            <p className='text'>E-mail: <a href={`mailto:${ data.email }`}> {data.email} </a></p>
                        </div>

                        <div className="text-container">
                            <div className="dot" />
                            <p className='text'>Instagram: @<a target='_blank' href={`https://www.instagram.com/${data.insta}`} rel="noopener noreferrer">{data.insta}</a></p>
                        </div>
                    </>
                    : <p>Error</p>
                }
            </div>
        </ContactsContainer>
    )
}

function TextItem({ text }) {
    return (
        <div className="text-container">
            <div className="dot" />
            <p className='text'>{text}</p>
        </div>
    )
}
